import axios from "axios";

export default {
    async requestUser({ commit }) {
        commit('loadingUser');

        try {
            const response = await axios.get(`${process.env.VUE_APP_BACKEND_API}/me/`);
            commit('successUser', response.data);
            commit('resetSuccessUser');
            return true;
        } catch(error) {
            commit('errorUser', error.response.data);
            return false;
        }
    },
    async updateUser({ commit, state }) {
        commit('loadingUser');

        try {
            const response = await axios.put(`${process.env.VUE_APP_BACKEND_API}/me/`, state.updatedData);
            commit('successUser', response.data);
            commit('resetSuccessUser');
            return true;
        } catch(error) {
            commit('errorUser', error.response.data);
            return false;
        }
    }
};
